import { useSuspenseQuery } from "@tanstack/react-query";
import { myDashboardApi } from "@/features/my-dashboard/api";

const useGetMyDashboardLineSheetByBrand = (
  buyer_id?: number,
  brand_id?: number
) => {
  const { data: myDashboardLineSheetByBrand } = useSuspenseQuery({
    queryFn: () => {
      if (!brand_id) return [];
      return myDashboardApi.getLineSheetByBrand({ buyer_id, brand_id });
    },
    queryKey: ["my-dashboard", "line-sheet-by-brand", brand_id, buyer_id],
  });

  return {
    myDashboardLineSheetByBrand,
  };
};

export default useGetMyDashboardLineSheetByBrand;
